// extracted by mini-css-extract-plugin
export default {"Section":"Section_Section__-pFvM"};